// extracted by mini-css-extract-plugin
export default {"block":"Login_block__g+B+J","link":"Login_link__Q9Eue"};